import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import RegisterWizard from "@/pages/RegisterWizard";
import Home from "@/pages/Home";
import VendorDashboard from "@/pages/VendorDashboard";
import MarriageServices from "@/pages/MarriageServices";
import Preferences from "@/pages/Preferences";
import Profile from "@/pages/Profile";
import AdminPanel from "@/pages/AdminPanel";
import HandoffIngest from "@/components/HandoffIngest";

/**
 * Vedika Sanskritik Bandhan — Web Routes
 * ------------------------------------------------------
 * /          → Landing (public — retains all compliance)
 * /register  → 6-page Matrimonial Onboarding Wizard (auth required)
 * /home      → Post-onboarding Dashboard (auth required, RULE A)
 * ------------------------------------------------------
 */
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HandoffIngest/>
        <Routes>
          <Route path="/" element={<Landing/>} />
          <Route path="/register" element={<RegisterWizard/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/preferences" element={<Preferences/>} />
          <Route path="/profile" element={<Profile/>} />
          <Route path="/admin" element={<AdminPanel/>} />
          <Route path="/vendor" element={<Navigate to="/vendor/dashboard" replace/>} />
          <Route path="/vendor/dashboard" element={<VendorDashboard/>} />
          <Route path="/vendors" element={<MarriageServices/>} />
          <Route path="*" element={<Navigate to="/" replace/>} />
        </Routes>
        <Toaster position="top-center" richColors closeButton/>
      </BrowserRouter>
    </div>
  );
}

export default App;
